import { cn } from "@/lib/utils";
import {
  statisticsShadcnCardClassName,
  statisticsShadcnCardContentClassName,
} from "@/views/Dashboard/Statistics/components/statisticsShadcnCardShell";

export const CUSTOM_CSV_BROKER_SELECT_TRIGGER_CLASS =
  "w-full max-w-full font-[family-name:var(--font-primary)] text-sm font-normal normal-case tracking-normal text-gray-500 [&_[data-slot=select-value]]:text-gray-500";

export const CUSTOM_CSV_SELECT_CONTENT_PROPS = {
  position: "popper" as const,
  side: "bottom" as const,
  sideOffset: 4,
  avoidCollisions: false,
  className: "z-[200]",
};

export const CUSTOM_CSV_FIELD_CARD_CLASS = statisticsShadcnCardClassName;

export const CUSTOM_CSV_FIELD_CARD_CONTENT_CLASS = cn(statisticsShadcnCardContentClassName, "pt-3");
